import axios from 'axios';
import React, { useState, useEffect, useMemo } from 'react'
import { API_BASE_URL } from '../utils/config';
import { Spinner } from 'react-bootstrap';
import NewTopNavBar from './NewTopNavBar';
import { MDBDataTable } from 'mdbreact';
import ReactDOMServer from 'react-dom/server';
import { useNavigate } from 'react-router-dom';
const Notifications = () => {
    let bearerToken = localStorage.getItem('jwt_token');
    const [apiRes, setApiRes] = useState([])
    const navigate = useNavigate();
    const config = {

        headers: {
            'Authorization': `Bearer ${bearerToken}`,
            'Content-Type': 'application/json',
        }
    };
    const getAllNotifications = () => {
        axios.get(`${API_BASE_URL}//wp-json/custom/v1/get-all-notification-data`, config).then((res) => {
            setApiRes(res.data)
        }).catch((err) => {
            console.log(err);
        })
    }
    useEffect(() => {
        getAllNotifications()

    }, []);
    const data = useMemo(() => (
        {
            columns: [
                {
                    label: 'Event Type',
                    field: 'event_type',
                    // sort: 'disabled',
                    width: 150
                },
                {
                    label: 'Date/Time',
                    field: 'date',
                    // sort: 'disabled',
                    width: 150
                },
                {
                    label: 'Event Message',
                    field: 'msg',
                    sort: 'disabled',
                    width: 150
                }
            ],

            rows: apiRes.map((e) => {
                let text = ""
                // let articlesLink = "";
                const handleArticleClick = (id, event_type) => {
                    // alert(id)
                    // if (event_type == 'Delete Article') {
                    //     return;

                    // }
                    if (id != "") {
                        localStorage.setItem('postId', id)
                        navigate(`/single-article?id=${id}`)
                    }
                }
                let event_type = e.event_type
                if (e.event_type == 'Like') {
                    text = `${e.author} ${e.isLiked} ${e.articles} articles.`
                    // articlesLink = <span>{e.articles}</span>;

                } else if (e.event_type == 'recommendation') {
                    text = `${e.author} recommendaed ${e.articles} articles to ${e.name} users.`
                }
                else if (e.event_type == 'Article Transferred') {
                    text = `${e.author} transfer ${e.articles} articles to ${e.name}.`
                } else if (e.event_type == 'Create New Article') {
                    text = `${e.author} created ${e.articles} articles.`
                } else if (e.event_type == 'Draft Article') {
                    text = `${e.author} drafted ${e.articles} articles.`
                }
                else if (e.event_type == 'Update Article') {
                    text = `${e.author} edited ${e.articles} articles.`
                } else if (e.event_type == 'Delete Article') {
                    text = `${e.author} deleted ${e.articles} articles.`
                } else if (e.event_type == 'Create New User') {
                    text = `${e.author} created ${e.name} ${e.user_role == 'subscriber' ? 'reader' : e.user_role}.`
                }
                else if (e.event_type == 'User Updated') {
                    text = `${e.author} edited ${e.name} ${e.user_role == 'subscriber' ? 'reader' : e.user_role}.`
                } else if (e.event_type == 'User Deleted') {
                    text = `${e.author} deleted ${e.name} ${e.user_role == 'subscriber' ? 'reader' : e.user_role}.`
                } else if (e.event_type == 'User Created via CSV') {
                    text = `${e.author} created ${e.value} users throw csv.`
                } else if (e.event_type == 'New Category Created') {
                    text = `${e.author} created ${e.category_name} category.`
                } else if (e.event_type == 'Update Category') {
                    text = `${e.author} updated ${e.category_name} category.`
                }
                else if (e.event_type == 'Delete Category') {
                    text = `${e.author} deleted ${e.category_name} category.`
                } else if (e.event_type == 'Create New Subcategory') {
                    text = `${e.author} created ${e.subcategory_name} subcategory.`
                } else if (e.event_type == 'Update Subcategory') {
                    text = `${e.author} updated ${e.subcategory_name} subcategory.`
                } else if (e.event_type == 'Delete Subcategory') {
                    text = `${e.author} deleted ${e.subcategory_name} subcategory.`
                } else if (e.event_type == 'New Tag Created') {
                    text = `${e.author} created ${e.tag_name} tag.`
                }
                else if (e.event_type == 'Update Tag') {
                    text = `${e.author} updated ${e.tag_name} tag.`
                }
                else if (e.event_type == 'Delete Tag') {
                    text = `${e.author} deleted ${e.tag_name} tag.`
                }
                else if (e.event_type == 'broadcast') {
                    if (e.value == true) {
                        text = `${e.author} create new broadcast ${e.notifications} for ${e.name}.`
                    } else {
                        text = `${e.author} create new broadcast ${e.notifications}.`
                    }
                }

                console.log("line126=", text)
                return Object.assign(e, {
                    msg: <p onClick={() => handleArticleClick(e.article_ids, event_type)} >{text}</p>,

                })
            })
        }



    ), [apiRes])

    useEffect(() => {

        let thead = document.querySelectorAll('th')
        console.log("432thead=", thead);
        for (let i = 0; i < thead.length; i++) {
            // if (rolles == "administrator" || "author") {
            if (i == 0) {
                thead[i].style.cssText = `width:20%; `
            }
            if (i === 1) {
                thead[i].style.cssText = `width:20%; `
            }
            // }
            // else {
            //   if (i === 0) {
            //     thead[i].style.cssText = `width:35%; `
            //   }
            // }
        }
    }, [apiRes]);

    return (
        <div>
            <NewTopNavBar />
            <div className='conatiner'>
                <div className="row g-0">
                    <div className="col-1"></div>
                    <div className="col-10">
                        <h3 className='pt-4'>Notifications</h3>
                        {/* <hr /> */}
                        {apiRes.length > 0 ? <div>
                            {/* {apiRes.map((value, index) => {
                                let text = ""
                                if (value.event_type == 'Like') {
                                    text = `${value.author} ${value.isLiked} ${value.articles} articles.`
                                } else if (value.event_type == 'recommendation') {
                                    text = `${value.author} recommendaed ${value.articles} articles to ${value.name} users.`
                                }
                                else if (value.event_type == 'Article Transferred') {
                                    text = `${value.author} transfer ${value.articles} articles to ${value.name}.`
                                }
                                return (
                                    <div >
                                        <p>{text}</p>
                                    </div>
                                )
                            })} */}

                            <MDBDataTable fixed sortable className='data-table text-capitalize' bordered entries={5} entriesOptions={[2, 5, 10, 15, 20]} data={data} noBottomColumns disableRetreatAfterSorting={true} />
                        </div> :

                            <div className='d-flex justify-content-center pt-5'>
                                <Spinner />
                            </div>
                        }
                    </div>
                    <div className="col-1"></div>

                </div>
            </div>
        </div>
    )
}

export default Notifications